/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  bindAuctionDateRequest,
  bindAuctioneerRequest,
  bindLoatNoRequest,
  bindSaleNoRequest,
  bindSessionTimeRequest,
  downloadAuctioneerExcelRequest,
  downloadAuctioneerPDFRequest,
  fetchAuctionRequest,
  fetchGradeRequest,
  fetchMarkRequest,
  getAllCategoriesAction,
  getAllTeaTypes,
  getBuyer,
  getDocumentByIdAction,
  getExportData,
  getExportDataApiCall,
  getSaleNoRequest,
} from "../../../store/actions";
import { useSelector } from "react-redux";
import CustomToast from "../../../components/Toast";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import axiosMain from "../../../http/axios/axios_main";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useRef } from "react";
import { useAuctionDetail } from "../../../components/common/AunctioneerDeteailProvider";
import Base64ToExcelDownload from "../../Base64ToExcelDownload";
import { uploadedFileDownload } from "../../uploadDocument/UploadedFileDownload";
import { NO_OF_RECORDS } from "../../../constants/commonConstants";
import { ThreeDots } from "react-loader-spinner";

function ViewDealBookAuctioneer({ modalRight }) {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = 0; i <= 5; i++) {
    const year = currentYear - i;
    years.push(year);
  }
  const [totalPackages, setTotalPackages] = useState(0);
  const [receivedQty, setreceivedQty] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const { auctionDetailId, auctionCenterUserId, auctionCenterId, userId } =
    useAuctionDetail();
  const [ViewDealBookTaoData, setViewDealBookTaoData] = useState([]);
  const [allTeaTypeList, setallTeaTypeList] = useState([]);
  const [allGrade, setallGrade] = useState([]);
  const [allSaleNoList, setallSaleNoList] = useState([]);
  const [allAuctionDate, setallAuctionDate] = useState([]);
  const [allSessionTime, setallSessionTime] = useState([]);
  const [allMarkList, setallMarkList] = useState([]);
  const [allAuctionCenterList, setallAuctionCenterList] = useState([]);
  const [allCategory, setallCategory] = useState([]);
  const [season, setSeason] = useState(currentYear);
  const [allLoatNo, setallLoatNo] = useState([]);
  const [allBuyer, setallBuyer] = useState([]);
  const [buyersPromptDate, setbuyersPromptDate] = useState("");
  const [allAuctioneerList, setallAuctioneerList] = useState([]);
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const [exportType, setexportType] = useState("");
  const [pageNo, setPageNo] = useState(2);
  const [loader, setLoader] = useState(false);
  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const [viewMore, setViewMore] = useState(false);
  const [DealBookSearch, setDealBookSearch] = useState({
    season: String(currentYear),
    saleNo: null,
    teaType: null,
    category: null,
    auctionDate: null,
    sessionTime: null,
    mark: null,
    buyerName: null,
    lotNo: null,
    auctionCentre: auctionCenterId,
    dealStatus: null,
    gradeName: null,
    auctioneerName: userId,
  });

  const allTeaType = useSelector(
    (state) => state.teaTypeManage.allTeaTypes.responseData
  );
  const getAllAuctionCenterList = useSelector(
    (res) => res.warehouseUserRegistration.auctionCenter?.responseData
  );
  const markList = useSelector((state) => state.mark.data.responseData);
  const allActiveCategory = useSelector(
    (state) => state.categoryManage.allCategories.responseData
  );
  const grades = useSelector((state) => state.grade.data.responseData);
  const getUploadedIdData = useSelector(
    (state) => state.documentReducer.documentData.responseData
  );
  const getUserData = useSelector(
    (state) => state.createBuyer.getBuyer.responseData
  );
  const saleNoData = useSelector((state) => state.saleNoReducer.saleList);
  const auctionDate = useSelector(
    (state) => state.saleNoReducer.auctionDateList
  );
  const loatNoList = useSelector((state) => state.saleNoReducer.loatNoList);
  const sessionTime = useSelector(
    (state) => state.saleNoReducer.sessionTimeList
  );
  const auctineerList = useSelector(
    (state) => state.saleNoReducer.auctineerList
  );
  const ExportExcelDatas = useSelector(
    (state) => state.documentReducer.exportData.responseData?.exported_file
  );
  const getExportDataApiCallResponse = useSelector(
    (state) => state.documentReducer.exportDataApiCall
  );

  const handleExport = (exportType) => {
    const updatedDealBookSearch = {
      ...DealBookSearch,
      url: "/postauction/dealbook/auctioneer/search",
      exportType: exportType,
      isExport: 1,
    };
    setexportType(exportType);
    dispatch(getExportData(updatedDealBookSearch));
  };
  const Validate = () => {
    let isValid = true;
    if (
      DealBookSearch.season == null ||
      DealBookSearch.season == "SELECT" ||
      DealBookSearch.season == ""
    ) {
      CustomToast.error("Please select season");
      isValid = false;
      return;
    }
    if (
      DealBookSearch.saleNo == null ||
      DealBookSearch.saleNo == "SELECT" ||
      DealBookSearch.saleNo == ""
    ) {
      CustomToast.error("Please select sale no");
      isValid = false;
      return;
    }
    return isValid;
  };
  const ViewDealBookList = async () => {
    try {
      const response = await axiosMain.post(
        "/postauction/dealbook/auctioneer/search",
        { ...DealBookSearch, pageNo: 1, noOfRecords: NO_OF_RECORDS }
      );

      if (response.data.statusCode === 200) {
        setPageNo(2);
        console.log(response.data.responseData, "response.data.responseData");
        setViewDealBookTaoData(response.data.responseData);
        response.data.responseData?.map(
          (ele, i) =>
            (document.getElementById(`remark-${i}`).value =
              response.data.responseData?.at(i).remarks)
        );
      } else if (response.data.statusCode === 404) {
        console.log(response.data.responseData, "response.data.responseData");
        setViewDealBookTaoData(response.data.responseData);
        response.data.responseData?.map(
          (ele, i) =>
            (document.getElementById(`remark-${i}`).value =
              response.data.responseData?.at(i).remarks)
        );
      } else {
        console.error("API Error:", response.data.message);
        // CustomToast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      // CustomToast.error("An error occurred while fetching data");
    }
  };
  const SearchViewDealBook = async (e) => {
    e.preventDefault();
    if (Validate()) {
      setViewDealBookTaoData([]);
      setLoader(true);
      const delay = new Promise((resolve) => setTimeout(resolve, 500));
      await delay;

      try {
        await ViewDealBookList();
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoader(false); // Set loader to false after execution
      }
    }
  };
  const handleViewMore = async () => {
    try {
      setViewMore(true);
      const response = await axiosMain.post(
        "/postauction/dealbook/auctioneer/search",
        {
          ...DealBookSearch,
          pageNo: pageNo,
          noOfRecords: NO_OF_RECORDS, // Pass NO_OF_RECORDS as 20
        }
      );
      if (response.data.statusCode == 200) {
        if (Array.isArray(response.data.responseData)) {
          if (response.data.responseData.length !== 0) {
            setViewDealBookTaoData((prevData) => [
              ...prevData,
              ...response.data.responseData,
            ]);
            setPageNo((prevPageNo) => prevPageNo + 1); // Increment pageNo
          }
        } else {
          console.error(
            "Response data is not an array:",
            response.data.responseData
          );
        }
        setViewMore(false);
      } else {
        setViewMore(false);
        CustomToast.error(response.data.message);
      }
    } catch (error) {
      setViewMore(false);
      console.error("Error:", error);
    }
  };
  const ResetViewBook = (e) => {
    e.preventDefault();
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
    setDealBookSearch({
      season: String(currentYear),
      saleNo: [],
      teaType: "",
      category: "",
      auctionDate: "",
      sessionTime: "",
      mark: "",
      buyerName: "",
      buyerPromptDate: "",
      lotNo: "",
      auctionCentre: auctionCenterId,
      dealStatus: "",
      gradeName: "",
      auctioneerName: userId,
    });
    setbuyersPromptDate("");
    setViewDealBookTaoData([]);

    setTimeout(() => {
      setDealBookSearch({
        season: String(currentYear),
        saleNo: null,
        teaType: null,
        category: null,
        auctionDate: null,
        sessionTime: null,
        mark: null,
        buyerName: null,
        buyerPromptDate: null,
        lotNo: null,
        auctionCentre: auctionCenterId,
        dealStatus: null,
        gradeName: null,
        auctioneerName: userId,
      });
    }, 0);
    dispatch(
      bindSaleNoRequest({
        season: String(DealBookSearch?.season),
        auctionCenterId: auctionCenterId,
      })
    );
  };
  const handleViewDealSearch = (e) => {
    const { name, value } = e.target;
    var selectedValue = value != "" ? value : null;
    setDealBookSearch({ ...DealBookSearch, [name]: selectedValue });
    setSeason(DealBookSearch.season);
  };

  useEffect(() => {
    if (ExportExcelDatas != null && true == getExportDataApiCallResponse) {
      dispatch(getExportDataApiCall(false));
      if ("excel" == exportType) {
        Base64ToExcelDownload(ExportExcelDatas, "View_DealBook.xlsx");
      } else {
        uploadedFileDownload(
          ExportExcelDatas,
          "View_DealBook.pdf",
          `data:application/pdf;base64`
        );
      }
    }
  });
  useEffect(() => {
    dispatch(getAllTeaTypes());
    dispatch(fetchMarkRequest({ auctionCenterId: auctionCenterId }));
    dispatch(fetchAuctionRequest());
    dispatch(getAllCategoriesAction());
    dispatch(fetchGradeRequest({ auctionCenterId }));
    dispatch(getBuyer({ roleCode: "BUYER", userType: 2, isParentId: 0 }));
    dispatch(bindAuctioneerRequest({ roleCode: "AUCTIONEER" }));
  }, []);
  useEffect(() => {
    if (DealBookSearch.season !== "") {
      dispatch(
        bindSaleNoRequest({
          season: DealBookSearch?.season,
          auctionCenterId: auctionCenterId,
        })
      );
      setViewDealBookTaoData([]);
    }
  }, [DealBookSearch.season]);
  useEffect(() => {
    if (DealBookSearch.saleNo !== null) {
      dispatch(
        bindAuctionDateRequest({
          season: DealBookSearch.season,
          saleNo: DealBookSearch.saleNo,
          auctionCenterId: auctionCenterId,
        })
      );
      dispatch(
        bindLoatNoRequest({
          season: DealBookSearch.season,
          saleNo: DealBookSearch.saleNo,
          auctionCenterId: auctionCenterId,
          pageNumber: 1,
          pageSize: 10,
          auctioneerId: userId,
        })
      );
      setViewDealBookTaoData([]);
    }
  }, [DealBookSearch.saleNo]);
  useEffect(() => {
    if (DealBookSearch.auctionDate !== null) {
      dispatch(
        bindSessionTimeRequest({
          season: DealBookSearch.season,
          saleNo: DealBookSearch.saleNo,
          auctionDate: DealBookSearch.auctionDate,
          auctionCenterId: auctionCenterId,
          auctioneerId: userId,
        })
      );
      setViewDealBookTaoData([]);
    }
  }, [DealBookSearch.auctionDate]);

  useEffect(() => {
    setViewDealBookTaoData([]);
  }, [DealBookSearch.sessionTime]);
  useEffect(() => {
    setViewDealBookTaoData([]);
  }, [DealBookSearch.teaType]);
  useEffect(() => {
    setViewDealBookTaoData([]);
  }, [DealBookSearch.category]);
  useEffect(() => {
    setViewDealBookTaoData([]);
  }, [DealBookSearch.mark]);
  useEffect(() => {
    setViewDealBookTaoData([]);
  }, [DealBookSearch.lotNo]);

  useEffect(() => {
    setallTeaTypeList(allTeaType);
    setallMarkList(markList);
    setallAuctionCenterList(getAllAuctionCenterList);
    setallCategory(allActiveCategory);
    setallGrade(grades);
    setallBuyer(getUserData);
    setallSaleNoList(saleNoData);
    setbuyersPromptDate(auctionDate[0]?.buyersPromptDate);
    setallLoatNo(loatNoList);
    setallSessionTime(sessionTime);
    setallAuctioneerList(auctineerList);
    setallAuctionDate(auctionDate);
  }, [
    allTeaType,
    currentYear,
    markList,
    getAllAuctionCenterList,
    allActiveCategory,
    grades,
    auctionDate,
    getUserData,
    saleNoData,
    auctionDate,
    loatNoList,
    sessionTime,
    auctineerList,
  ]);
  useEffect(() => {
    let totalPackages = 0;
    let receivedQty = 0;
    let totalValue = 0;

    ViewDealBookTaoData?.forEach((item) => {
      totalPackages += item.qtyReceived;
      receivedQty += item.receivedQty;
      totalValue += item.receivedQty * item.priceKG;
    });

    setTotalPackages(parseFloat(totalPackages.toFixed(2)));
    setreceivedQty(parseFloat(receivedQty.toFixed(2)));
    setTotalValue(parseFloat(totalValue.toFixed(2)));
  }, [ViewDealBookTaoData]);

  return (
    <div>
      <div>
        {modalRight?.some((ele) => ele === "12") && (
          <>
            <form onSubmit={SearchViewDealBook}>
              <div className="row">
                <div className="col-xl-2">
                  <div className="FomrGroup">
                    <label>Season</label>
                    <label className="errorLabel"> * </label>
                    <select
                      name="season"
                      value={DealBookSearch.season}
                      className="form-control select-form"
                      onChange={handleViewDealSearch}
                    >
                      <option value="">Select Season</option>
                      {years.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-xl-2">
                  <div className="FomrGroup">
                    <label>Sale No</label>
                    <label className="errorLabel"> * </label>
                    <select
                      name="saleNo"
                      onChange={handleViewDealSearch}
                      value={DealBookSearch.saleNo}
                      className="form-control select-form"
                    >
                      <option value="">Select Sale No</option>
                      {allSaleNoList.map((saleNoItem, index) => (
                        <option value={saleNoItem.saleNo} key={index}>
                          {saleNoItem.saleNo}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-xl-2">
                  <div className="FomrGroup">
                    <label>Auction Date </label>
                    <select
                      name="auctionDate"
                      value={DealBookSearch.auctionDate}
                      className="form-control select-form"
                      onChange={handleViewDealSearch}
                    >
                      <option value="">Select Auction Date </option>
                      {allAuctionDate?.map((allAuctionDate, index) => (
                        <option value={allAuctionDate.saleDate}>
                          {allAuctionDate.saleDate}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-xl-2">
                  <div className="FomrGroup">
                    <label>Session Time</label>
                    <select
                      name="sessionTime"
                      value={DealBookSearch.sessionTime}
                      className="form-control select-form"
                      onChange={handleViewDealSearch}
                    >
                      <option value="">Select Session Time </option>
                      {allSessionTime?.map((allSessionTime, index) => (
                        <option value={allSessionTime.SessionTime}>
                          {allSessionTime.SessionTime}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-xl-2">
                  <div className="FomrGroup">
                    <label>Tea Type</label>
                    <select
                      name="teaType"
                      value={DealBookSearch.teaType}
                      className="form-control select-form"
                      onChange={handleViewDealSearch}
                    >
                      <option value="">Select Tea Type</option>
                      {allTeaTypeList?.map((allTeaTypeList, index) => (
                        <option value={allTeaTypeList.teaTypeId}>
                          {allTeaTypeList.teaTypeName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-xl-2">
                  <div className="FomrGroup">
                    <label>Category</label>
                    <select
                      name="category"
                      value={DealBookSearch.category}
                      className="form-control select-form"
                      onChange={handleViewDealSearch}
                    >
                      <option value="">Select Category</option>
                      {allCategory?.map((allCategory, index) => (
                        <option value={allCategory.categoryId}>
                          {allCategory.categoryCode}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-xl-2">
                  <div className="FomrGroup">
                    <label>Mark</label>
                    <select
                      name="mark"
                      value={DealBookSearch.mark}
                      className="form-control select-form"
                      onChange={handleViewDealSearch}
                    >
                      <option value="">Select Mark</option>
                      {allMarkList?.map((allMarkList, index) => (
                        <option value={allMarkList.markId}>
                          {allMarkList.markName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-xl-2">
                  <div className="FomrGroup">
                    <label>Buyer's Prompt Date</label>
                    <input
                      type="text"
                      name="buyerPromptDate"
                      className="form-control"
                      value={buyersPromptDate}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-xl-2">
                  <div className="FomrGroup">
                    <label>Lot No</label>
                    <select
                      name="lotNo"
                      value={DealBookSearch.lotNo}
                      className="form-control select-form"
                      onChange={handleViewDealSearch}
                    >
                      <option value="">Select Lot No</option>
                      {allLoatNo.map((allLoatNo, index) => (
                        <option value={allLoatNo.LOT} key={index}>
                          {allLoatNo.LOT}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-xl-2">
                  <div className="FomrGroup">
                    <label>Auction Center </label>
                    <select
                      name="auctionCentre"
                      value={DealBookSearch.auctionCentre}
                      className="form-control select-form"
                      onChange={handleViewDealSearch}
                    >
                      <option value="">Select Auction Center</option>
                      {allAuctionCenterList?.map(
                        (allAuctionCenterList, index) => (
                          <option value={allAuctionCenterList.auctionCenterId}>
                            {allAuctionCenterList.auctionCenterName}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </div>
                <div className="col-12">
                  <div className="BtnGroup">
                    <button type="submit" className="SubmitBtn">
                      Search
                    </button>
                    <button
                      type="button"
                      className="SubmitBtn"
                      onClick={ResetViewBook}
                    >
                      Reset
                    </button>

                    {modalRight?.some((ele) => ele === "48") && (
                      <button
                        type="button"
                        className="Excel"
                        title="Export Excel"
                        onClick={() => handleExport("excel")}
                      >
                        <i className="fa fa-file-excel"></i>
                      </button>
                    )}
                    {modalRight?.some((ele) => ele === "47") && (
                      <button
                        type="button"
                        className="Excel"
                        title="Export PDF"
                        onClick={() => handleExport("pdf")}
                      >
                        <i className="fa fa-file-pdf"></i>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </form>
            <div className="row mt-4">
              <div className="col-12">
                <div className="row my-4">
                  <div className="col-md-auto">
                    <strong>
                      <span className="totals">Total Count :</span>{" "}
                      {ViewDealBookTaoData === [] ||
                      ViewDealBookTaoData === undefined ||
                      ViewDealBookTaoData === null
                        ? 0
                        : ViewDealBookTaoData?.length}
                    </strong>
                  </div>
                </div>
                <div className="TableBox2">
                  <table className="table2">
                    <thead>
                      <tr>
                        <th>Sr.</th>
                        <th>Lot No</th>
                        <th>Mark</th>
                        <th>Grade</th>
                        <th>Invoice No</th>
                        <th>Qty. Received</th>
                        <th>Preferences</th>
                        <th>Auction Center</th>
                        <th>Packages / Total Packages</th>
                        <th>Total Gross Weight </th>
                        <th>Sample Qty</th>
                        <th>Short/Excess Weight</th>
                        <th>Category </th>
                        <th>Sub Tea Type </th>
                        <th>Session Type </th>
                        <th>Buyer Name</th>
                        <th>Price Per KG/Knockdown price</th>
                        <th>Deal No</th>
                        <th>Deal Time</th>
                        <th>Within State</th>
                        <th>Inter State</th>
                        <th>Export</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ViewDealBookTaoData?.length > 0 ? (
                        <>
                          {ViewDealBookTaoData?.map((data, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{data.lotNo}</td>
                              <td>{data.mark}</td>
                              <td>{data.grade}</td>
                              <td>{data.invoiceNo}</td>
                              <td>{data.receivedQty}</td>
                              <td>{data.preferences}</td>
                              <td>{data.auctionCentre}</td>
                              <td>{data.packages}</td>
                              <td>{data.totalGrossWeight}</td>
                              <td>{data.sampleQty}</td>
                              <td>{data.shortWeight}</td>
                              <td>{data.category}</td>
                              <td>{data.subTeaType}</td>
                              <td>{data.sessionType}</td>
                              <td>{data.buyerName}</td>
                              <td>{data.priceKG}</td>
                              <td>{data.dealNo}</td>
                              <td>{data.dealTime}</td>
                              <td>{data.withinState}</td>
                              <td>{data.interstate}</td>
                              <td>{data.export}</td>
                              <td className="d-none">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="updatedBy"
                                  value={data.updatedBy}
                                />
                              </td>
                            </tr>
                          ))}
                        </>
                      ) : (
                        <>
                          <tr>
                            <td colSpan={30}>
                              {loader ? (
                                <>
                                  <div className="">
                                    <ThreeDots
                                      visible={true}
                                      height="80"
                                      width="80"
                                      color="#4fa94d"
                                      radius="9"
                                      ariaLabel="three-dots-loading"
                                      wrapperStyle={{}}
                                      wrapperClass=""
                                    />
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="NoData">No record found</div>
                                </>
                              )}
                            </td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="d-none">
                  {selectedRowsData.length > 0 && (
                    <table ref={tableRef}>
                      <thead>
                        <tr>
                          <th>Sr.</th>
                          <th>Lot No</th>
                          <th>Mark</th>
                          <th>Grade</th>
                          <th>Invoice No</th>
                          <th>Qty. Received</th>
                          <th>Preferences</th>
                          <th>Auction Center</th>
                          <th>Packages / Total Packages</th>
                          <th>Total Gross Weight </th>
                          <th>Sample Qty</th>
                          <th>Short/Excess Weight</th>
                          <th>Category </th>
                          <th>Sub Tea Type </th>
                          <th>Session Type </th>
                          <th>Buyer Name</th>
                          <th>Price</th>
                          <th>Deal No</th>
                          <th>Deal Time</th>
                          <th>Within State</th>
                          <th>Inter State</th>
                          <th>Export</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedRowsData.map((data, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{data.lotNo}</td>
                            <td>{data.mark}</td>
                            <td>{data.grade}</td>
                            <td>{data.invoiceNo}</td>
                            <td>{data.qtyReceived}</td>
                            <td>{data.preferences}</td>
                            <td>{data.auctionCentre}</td>
                            <td>{data.packages}</td>
                            <td>{data.totalGrossWeight}</td>
                            <td>{data.sampleQty}</td>
                            <td>{data.shortWeight}</td>
                            <td>{data.category}</td>
                            <td>{data.subTeaType}</td>
                            <td>{data.sessionType}</td>
                            <td>{data.buyerName}</td>
                            <td>{data.priceKG}</td>
                            <td>{data.dealNo}</td>
                            <td>{data.dealTime}</td>
                            <td>{data.withinState}</td>
                            <td>{data.interstate}</td>
                            <td>{data.export}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>

                <div className="row my-4">
                  <div className="col-md-auto">
                    <strong>
                      <span className="totals">Total Packages :</span>{" "}
                      {totalPackages}
                    </strong>
                  </div>
                  <div className="col-md-auto">
                    <strong>
                      <span className="totals">Qty. Received :</span>{" "}
                      {receivedQty}
                    </strong>
                  </div>
                  <div className="col-md-auto">
                    <strong>
                      <span className="totals">Total Value :</span> {totalValue}
                    </strong>
                  </div>
                </div>
                {ViewDealBookTaoData?.length > 19 ? (
                  <div className="BtnGroup text-center justify-content-center">
                    <button
                      class="SubmitBtn"
                      type="button"
                      onClick={handleViewMore}
                      disabled={viewMore}
                    >
                      View More
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ViewDealBookAuctioneer;
